<template>
  <div id="app">
    <NavigationBar />
    <router-view/>
    <FooterBar />
  </div>
</template>
<script>
import NavigationBar from "./components/NavigationBar.vue";
import FooterBar from "./components/FooterBar.vue";
export default {
   components: {
     NavigationBar,
     FooterBar
   }
}
</script>
<style>

@import url('https://fonts.googleapis.com/css2?family=Outfit&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oswald&display=swap');
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color:var(--truecaller-background);
}

#nav a.router-link-exact-active {
  color: #42b983;
}
a:link {color: rgb(31, 31, 31);} 
a:visited {color: rgb(31, 31, 31)}  
a:hover {color: rgb(31, 31, 31)}  
a:active {color: rgb(31, 31, 31)}   
* {
box-sizing: border-box;
margin: 0;
border: 0;
}
:root{
  --black:#333;
  --white:rgb(255, 255, 255);
  --blue:rgb(24, 125, 219);
  --truecaller-background: rgb(238, 236, 236);
}
</style>
